
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 5h22v22H5V5zm2 2v5h5V7H7zm7 0v5h4V7h-4zm6 0v5h5V7h-5zM7 14v4h5v-4H7zm7 0v4h4v-4h-4zm6 0v4h5v-4h-5zM7 20v5h5v-5H7zm7 0v5h4v-5h-4zm6 0v5h5v-5h-5z"}})])
          )
        }
      }
    